
import React from 'react';
import { Box } from 'grommet';
import { ScatterChart } from 'grommet-controls';
import { isInteger } from 'lodash';

const ROKY = [1941, 1951, 1961, 1971, 1981, 1991, 2001, 2011];
const ROKY_2 = [[1941, 1950], [1951, 1960], [1961, 1970], [1971, 1980], [1981, 1990], [1991, 2000], [2001, 2010], [2011,2016]];

const getXLabel = (value) => {
    if (isInteger(value)) {
        const roky = ROKY_2[value];
        if (roky) {
            return `${roky[0]} až ${roky[1]}`;
        }
    }
}

const getXValue = (rokOd) => {
    return ROKY.indexOf(rokOd);
}

const getChartDataSet = (tratContent, odruda) => {
    const contentForOdruda = tratContent.filter(item => {
        return (item.odruda_zkratka === odruda.zkratka);
    });

    const dataSet = {
        label: odruda.nazev,
        data: contentForOdruda.map(item => {
            return {
                x: getXValue(item['rok_od']),
                y: item['value']
            };
        }),

        fill: false,
        hintName: odruda.nazev,
        showLine: true
    };
    return dataSet;
}

const getChartDataSets = (tratContent) => {
    let odrudyZkratky = [];
    let odrudy = [];
    tratContent.forEach(item => {
        if (odrudyZkratky.indexOf(item.odruda_zkratka) === -1) {
            odrudyZkratky.push(item.odruda_zkratka);
            odrudy.push({
                zkratka: item.odruda_zkratka,
                nazev: item.odruda_nazev
            });
        }
    });

    const dataSets = odrudy.map(item => {
        return getChartDataSet(tratContent, item);
    });

    return dataSets;
}

const OdrudyTratGraf = ({tratContent, windowSize = ''}) => {
    return (
        <Box height="600px">
            <ScatterChart
                data={{
                    datasets: getChartDataSets(tratContent)
                }}
                options={{
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                const odruda = data.datasets[tooltipItem.datasetIndex].label || '';
                                const obdobi = getXLabel(tooltipItem.xLabel);
                                const value = tooltipItem.yLabel;
                                return `${odruda}: ${obdobi} bylo ${value}%`;
                            }
                        }
                    },
                    legend: {
                        position: 'top'
                    },
                    scales: {
                        yAxes: [{
                            id: 'yAxis1',
                            gridLines: {
                                color: 'rgba(0, 0, 0, 0.1)',
                                borderDash: [5]
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'zastoupení odrůdy (%)'
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                callback: (value, index, values) => {
                                    return getXLabel(value);
                                }
                            },
                            gridLines: {
                                color: 'rgba(0, 0, 0, 0.1)',
                                borderDash: [5]
                            }
                        }]
                    }
                }}
            />
        </Box>
    );
};

export default OdrudyTratGraf;
